import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';
import SnackBar from "components/SnackBar";
import {  userSignIn } from 'actions/Auth';
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from '@material-ui/core/Button'
import logov from "assets/images/logo_v.png"
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import URLSearchParams from "url-search-params";
import API from 'util/Api'
import * as Yup from "yup";
import {  Box, Typography } from "@material-ui/core";

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .transform((value) => (value ? value.trim() : value)) 
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Enter a valid email"
    )
    .required("Email is required"),
});


const validationSchemaOTP = Yup.object().shape({
  otp: Yup.string()
    .test("otp-length", "OTP is required", function (_, context) {
      const { otp1, otp2, otp3, otp4, otp5, otp6 } = context.parent;
      const otpArray = [otp1, otp2, otp3, otp4, otp5, otp6];
      return otpArray.every((val) => val && val.trim() !== ""); // Ensure all OTP fields are filled
    }),

  password: Yup.string()
    .min(6, "Password must be at least 6 characters long")
    .required("Password is required"),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Confirm Password is required"),
});



const ForgetPassword = (props) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector(({ auth }) => auth.token);
  const { message } = useSelector(({ commonData }) => commonData);
  const [otpValues, setOtpValues] = useState(Array(6).fill(""));
  const [tokenLogin, setTokenLogin] = useState(true);
  const [snackBar, setSnackBar] = useState({
    open: false,
    message: "",
    type: "error",
});

  const inputRefs = useRef([]);

  // Handle auto-focus on OTP inputs
  const handleOTPChange = (e, index, setFieldValue) => {
    const { value } = e.target;
    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
    setFieldValue(`otp${index + 1}`, value);
  };

  
  useEffect(() => {
    if (token !== null) {      
      const params = new URLSearchParams(window.location.search);
      const referrer = params.get("referrer") || "/";
      props.history.push(referrer);
    }
  }, [token]);

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    if(params.has("secret")){
      const secret = params.get("secret");
      setTokenLogin(true);
      dispatch(userSignIn({ email, password, secret }))
    }else{
      setTokenLogin(false);
    }
  }, [props.location.search])

 const sendOtp = ({email}) => {
    setLoading(true)
    API.post('forgotPassword', {
      email: email ? email : undefined
    }
    ).then(({ data }) => {
      setOtpSent(true);
      setEmail(email)
    }).catch(function (err) {
      setSnackBar({
        open: true,
        message: err?.response?.data?.msg,
        type: "error",
    })

    }).finally(()=>{
      setLoading(false)
    })
  };

  const changePassword = (values)=>{
    if(values.password !== values.confirmPassword){
        setSnackBar({
          open: true,
          message:'Password does not match',
          type: "error",
      });
      return;
    }
    const otp = values.otp1 + values.otp2 + values.otp3 + values.otp4 + values.otp5 + values.otp6;
    const updatedValues = { otp,email:email, password:values.password };
    API.post('resetPassword', updatedValues).then((response) => {
      setSnackBar({
        open: true,
        message: "Password changed successfully",
        type: "success",
      });
      setTimeout(() => {
            props.history.push('/signin')
      }, 100);
    }).catch(function (err) {
      setSnackBar({
        open: true,
        message: "Invalid OTP",
        type: "error",
      });

    }).finally(()=>{
      setLoading(false)
    })
  }
  return (
    !tokenLogin && 
    <div
      className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
      <div className="login-content" style={{width:'80%'}}>
        <div className="login-header">
          <Link className="app-logo" to="/" title="ValetEZ">
            <img src={logov} alt="ValetEZ" title="ValetEZ" />
          </Link>
        </div>
        {
          !otpSent ? 
              <EmailContainer loading={loading} sendOtp={sendOtp} message={message}/>
            :
              <OtpContainer changePassword={changePassword} inputRefs={inputRefs} handleOTPChange={handleOTPChange} loading={loading}/>
        }
      </div>
      {
        loading &&
        <div className="loader-view">
          <CircularProgress />
        </div>
      }
      <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar({ open: false, message: "" });
                }}
            />
    </div>
  );
};



const OtpContainer = ({changePassword, inputRefs, handleOTPChange, loading})=>{
  return (
    <div className="login-form ">
    <Formik
      initialValues={{
        otp1: "", otp2: "", otp3: "", otp4: "", otp5: "", otp6: "",
        password: "",
        confirmPassword: "",
      }}
      validationSchema={validationSchemaOTP}
      onSubmit={(values) => {
        changePassword(values);
      }}
    >
    {({ handleSubmit, setFieldValue,errors,touched }) => (
      <Form onSubmit={handleSubmit}  autoComplete="new-password">
        <Box display="flex" flexDirection="column" height="100%">
          <Box mb={2}>
            <Typography variant="body2">Enter OTP</Typography>

            <Box display="flex" justifyContent="space-between"  mb={3} mt={1}>
            {[...Array(6)].map((_, index) => (
              <Field
              autoComplete="new-password"
              key={index}
                component={TextField}
                name={`otp${index + 1}`}
                variant="outlined"
                inputRef={(el) => (inputRefs.current[index] = el)}
                disabled={loading}
                inputProps={{
                  maxLength: 1,
                  style: { textAlign: "center" },
                  onChange: (e) => handleOTPChange(e, index, setFieldValue),
                  inputMode: "numeric",
                  autoComplete: "one-time-code",
                }}
                style={{ width: "3rem", marginRight: "0.5rem" }}
              />
            ))}
          </Box>
          {errors.otp  && <Typography variant="body2" color="error" style={{marginBottom:10}}>{errors.otp}</Typography>}

            <Field
              component={TextField}
              name="password"
              label="Enter Password"
              type="password"
              variant="outlined"
              disabled={loading}
              fullWidth
            />

            <Field
              component={TextField}
              name="confirmPassword"
              label="Enter Confirm Password"
              type="password"
              disabled={loading}
              variant="outlined"
              fullWidth
              style={{ marginTop: "1rem" }}
            />
          </Box>

          <Box display="flex" justifyContent="end">
            <Button
              // disabled={loading}
              variant="contained"
              color="primary"
              style={{width:'8rem'}}
              sx={{
                backgroundColor: !loading ? 'primary.main' : 'primary.loading', 
                color: '#fff', 
                padding: '5px 15px', 
                width:'8rem',
                borderRadius: 1,  
                borderRadius:25,
                padding:5,
                '&.MuiButtonBase-root': {
                    backgroundColor: !loading ? 'primary.main' : 'primary.loading', 
                    color: '#fff !important',
                    borderRadius:1,
                    padding: '5px 15px', 
                },
              }}
              type="button"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Box>

          <Typography variant="body2"  style={{ marginTop: "1rem" }}>
            Already have an account?{" "}
            <Link to="/app/signIn">
              Login Now
            </Link>
          </Typography>
        </Box>
      </Form>
    )}
    </Formik>
</div>
  )
}

const EmailContainer = ({sendOtp, loading, message})=>{
  return(
    <div className="login-form ">
      <Formik
      initialValues={{ email: "" }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        sendOtp({ email: values.email });
      }}
    >
      {({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <fieldset>
            <div className="form-group">
              <Field
                component={TextField}
                name="email"
                id="email"
                label="Enter Registered Email Address"
                variant="outlined"
                disabled={loading}
                fullWidth
              />
            </div>

            <div className="form-group d-flex justify-content-between align-items-center">
              {message && <div>{message}</div>}
              <div className="d-flex justify-content-end w-100">
                <Button style={{width:'8rem'}}
                sx={{
                  backgroundColor: !loading ? 'primary.main' : 'primary.loading', 
                  color: '#fff', 
                  padding: '5px 15px', 
                  width:'8rem',
                  borderRadius: 1,  
                  borderRadius:25,
                  padding:5,
                  '&.MuiButtonBase-root': {
                      backgroundColor: !loading ? 'primary.main' : 'primary.loading', 
                      color: '#fff !important',
                      borderRadius:1,
                      padding: '5px 15px', 
                  },
                }}
                disabled={loading} type="submit" variant="contained" color="primary">
                  Send
                </Button>
              </div>
            </div>

            <div>
              Already have an account?{" "}
              <Link to="/app/signIn" title="Reset Password">
                Login Now
              </Link>
            </div>
          </fieldset>
        </Form>
      )}
      </Formik>
    </div>
  )
}
export default ForgetPassword;
